import Card from "../Card";
import { PreviewWrapper, SectionTitle } from "./style";

const Preview = (props) => {
  const { cards } = props;
  return (
    <PreviewWrapper>
      <SectionTitle>카드 미리보기</SectionTitle>
      <ul>
        {Object.keys(cards).map((key) => (
          <Card data={cards[key]} key={key} />
        ))}
      </ul>
    </PreviewWrapper>
  );
};

export default Preview;
